/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/layout/get-field-zone-layout";
import { DateFieldDisplay } from "./display";
import { DateFieldEdit } from "./edit";

const DateField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <DateFieldDisplay />,
        editComponent: <DateFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
DateField.displayName = "DateField";
export { DateField };
